import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../core/configuration/properties-settings";
import { Fattura } from '../models/fattura';
import { NumericOperationManager } from '../utils/numeric-operation-manager';

@Component({
    selector: 'div [fattura-riepilogo-form]',
  templateUrl: 'fattura-riepilogo-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class FatturaRiepilogoForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input() fattura: Fattura;

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  getDiff(a: string, b: string) {
    return NumericOperationManager.getDiff(a, b);
  }
}
